@if (pagelet()?.hasParam('HTMLText')) {
<span [ishServerHtml]="pagelet().stringParam('HTMLText')"></span>
}
